import type { CrunchData } from '@dc-shared-web/hooks/api/document/types'
import { AxiosInstance } from 'axios'

export const fetchDocumentById = async (
  apiClient: AxiosInstance,
  documentId: string
): Promise<CrunchData> => {
  const {
    data: { data },
  } = await apiClient.get(`/api/crunch/${documentId}`)
  return data
}
